import type { NewApprovalNotificationConfig } from '../../../../domain/types/configs/company/NotificationConfig';

export const newApprovalNotificationConfig: NewApprovalNotificationConfig = {
  recipients: [
    {
      send: false,
      company: "FRESENIUS",
      contact: "vmolinar@vml-sa.com"
    },
    {
      contact: "sonia.vanegas@dawipo.com",
      company: "FRESENIUS",
      send: false
    },
    {
      contact: "ap@cooweb.co",
      send: false,
      company: "FRESENIUS"
    }
  ]
}; 